/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterValidateLoginRequest
 */
export interface RegisterValidateLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterValidateLoginRequest
     */
    cipher: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterValidateLoginRequest
     */
    tag: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterValidateLoginRequest
     */
    nonce: string;
}

/**
 * Check if a given object implements the RegisterValidateLoginRequest interface.
 */
export function instanceOfRegisterValidateLoginRequest(value: object): value is RegisterValidateLoginRequest {
    if (!('cipher' in value) || value['cipher'] === undefined) return false;
    if (!('tag' in value) || value['tag'] === undefined) return false;
    if (!('nonce' in value) || value['nonce'] === undefined) return false;
    return true;
}

export function RegisterValidateLoginRequestFromJSON(json: any): RegisterValidateLoginRequest {
    return RegisterValidateLoginRequestFromJSONTyped(json, false);
}

export function RegisterValidateLoginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterValidateLoginRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'cipher': json['cipher'],
        'tag': json['tag'],
        'nonce': json['nonce'],
    };
}

export function RegisterValidateLoginRequestToJSON(json: any): RegisterValidateLoginRequest {
    return RegisterValidateLoginRequestToJSONTyped(json, false);
}

export function RegisterValidateLoginRequestToJSONTyped(value?: RegisterValidateLoginRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cipher': value['cipher'],
        'tag': value['tag'],
        'nonce': value['nonce'],
    };
}

